import { CanMatchFn } from '@angular/router';
import { JwtService } from '../../../shared/services/jwt.service';
import { inject } from '@angular/core';

export const authGuard: CanMatchFn = (route, segments) => {
  const jwtService: JwtService = inject(JwtService);
  //if(jwtService.checkSessionTimeout()){
  if (jwtService.checkToken()) {
    return true;
  }
  else {
    jwtService.logout();
    return false;
  }
};
